export default "__VITE_ASSET__103ff051__"